import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import PersonnelTable from "@/components/operations/personnel/personnel-table";

const personnelSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/operations/personnel/")({
  validateSearch: personnelSearchSchema,
  component: PersonnelPage,
});

function PersonnelPage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "personnel", actions: ["read"] }]}>
      
    <div className="flex-1 flex flex-col min-h-0">
      <div className="flex-1 min-h-0">
        <PersonnelTable
          currentPage={searchParams.page}
          basePath="/operations/personnel"
          searchParams={searchParams}
        />
      </div>
    </div>
  
    </RouteGuardPermissions>
  );
}
